"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlowEffectHandler = exports.SlowEffectArgs = void 0;
const Duration_1 = require("../../Duration");
const AttributeType_1 = require("../../enums/AttributeType");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
const MaxAttributeIncrease_1 = require("./MaxAttributeIncrease");
class SlowEffectArgs {
    constructor(stacks) {
        this.stacks = stacks;
        this.__type = EffectType_1.EffectType.Slow;
        this.__typeName = "Slow";
        this.name = "Slow";
        this.harmful = true;
    }
}
exports.SlowEffectArgs = SlowEffectArgs;
let SlowEffectHandler = class SlowEffectHandler {
    apply(sequence, container, state) {
        state.meta.effectId = container.applyDebuff({
            sequence,
            attackerId: state.creatorId,
            targetId: state.targetId,
            effect: new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.SlowStacks, state.args.stacks),
            duration: Duration_1.Duration.Permanent,
        });
    }
    remove(sequence, container, state) {
        container.cancelEffect(sequence, state.meta.effectId);
    }
};
SlowEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Slow)
], SlowEffectHandler);
exports.SlowEffectHandler = SlowEffectHandler;
